export const getLocalStorageItem = (key: string, defaultValue = {}) => {
  const localStoreValue = localStorage.getItem(key);
  return localStoreValue ? JSON.parse(localStoreValue) : defaultValue;
};

export const addLocalStorageItem = (key: string, value: Record<string, unknown>): void => {
  localStorage.setItem(
    key,
    JSON.stringify({
      ...getLocalStorageItem(key),
      ...value
    })
  );
};
